/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadPalInfo } from './LeadPalInfo';
import {
    LeadPalInfoFromJSON,
    LeadPalInfoFromJSONTyped,
    LeadPalInfoToJSON,
    LeadPalInfoToJSONTyped,
} from './LeadPalInfo';

/**
 * 
 * @export
 * @interface FindOnePalInfo200Response
 */
export interface FindOnePalInfo200Response {
    /**
     * 
     */
    data?: LeadPalInfo;
}

/**
 * Check if a given object implements the FindOnePalInfo200Response interface.
 */
export function instanceOfFindOnePalInfo200Response(value: object): value is FindOnePalInfo200Response {
    return true;
}

export function FindOnePalInfo200ResponseFromJSON(json: any): FindOnePalInfo200Response {
    return FindOnePalInfo200ResponseFromJSONTyped(json, false);
}

export function FindOnePalInfo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOnePalInfo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : LeadPalInfoFromJSON(json['data']),
    };
}

export function FindOnePalInfo200ResponseToJSON(json: any): FindOnePalInfo200Response {
    return FindOnePalInfo200ResponseToJSONTyped(json, false);
}

export function FindOnePalInfo200ResponseToJSONTyped(value?: FindOnePalInfo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadPalInfoToJSON(value['data']),
    };
}

